import { render } from "./MfMultiSelect.vue?vue&type=template&id=3b17431f"
import script from "./MfMultiSelect.vue?vue&type=script&lang=js"
export * from "./MfMultiSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__